import CourseDataStore from '../../datastores/CourseDataStore';

export default class CourseDataStoreMock implements CourseDataStore {
  progressiveCertificationEnabled() {
    return true;
  }

  async getCourseSummary() {
    const data = {
      getCourseSummary: {
        average: '16.2',
        campus: 'Ica',
        creditCount: '20',
        enrolledCourses: '6',
        meritOrder: '66 de 255',
        relativeCycle: '1',
        weeklyHours: '22'
      }
    };
    const response = data?.getCourseSummary;
    return response;
  }

  async getEnrolledPeriodsByStudent() {
    const data = {
      getPeriodsByStudent: [
        {
          id: '1',
          name: '2022 - Ciclo 2 Agosto'
        },
        {
          id: '2',
          name: '2022 - Ciclo 1 Marzo'
        }
      ]
    };
    const response = data?.getPeriodsByStudent;
    return response;
  }

  async getCourses() {
    const data = {
      student: {
        courses: [
          {
            id: '013391',
            name: 'QUIMICA GENERAL',
            code: '100000I02N',
            module: '001',
            classId: '1132',
            professors: []
          },
          {
            id: '013776',
            name: 'COMPRENSION Y REDACCION DE TEXTOS I',
            code: '100000N01I',
            module: '001',
            classId: '1134',
            professors: []
          },
          {
            id: '013785',
            name: 'INGLES I',
            code: '100000N03I',
            module: '001',
            classId: '1136',
            professors: []
          },
          {
            id: '013398',
            name: 'INTRODUCCION A LA MATEMATICA PARA INGENIERIA',
            code: '100000I03N',
            module: '001',
            classId: '1133',
            professors: []
          },
          {
            id: '017235',
            name: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: INGENIERÍA Y PROCESOS INDUSTRIALES',
            code: '200000I96N',
            module: '001',
            classId: '1137',
            professors: []
          },
          {
            id: '013778',
            name: 'INVESTIGACION ACADEMICA',
            code: '100000N02I',
            module: '001',
            classId: '1135',
            professors: []
          }
        ]
      }
    };
    const { courses } = data?.student;
    return courses;
  }

  async getClassAttendance() {
    const data = {
      getClassAttendance: {
        course: 'Curso de Ejemplo',
        summary: {
          attended: 20,
          noAttended: 5,
          pending: 3,
          noRecord: 2
        },
        months: [
          {
            name: 'Marzo 2024',
            date: [
              { name: 'Lun 01', type: 'P' },
              { name: 'Lun 08', type: 'NR' },
              { name: 'Lun 15', type: 'A' },
              { name: 'Lun 29', type: 'NA' },
              { name: 'Lun 30', type: 'NA' }
            ]
          },
          {
            name: 'Abril 2024',
            date: [
              { name: 'Lun 06', type: 'P' },
              { name: 'Lun 13', type: 'P' },
              { name: 'Lun 20', type: 'A' }
            ]
          }
        ]
      }
    };
    const response = data?.getClassAttendance;
    return response;
  }
}
